import React from 'react'

import styles from './index.module.css'

type Option = {
  label: string
  value: string | number
}

export type SpSelectProps = {
  options: Option[]
  value: string | number | null
  placeholder?: string
  isDisabled?: boolean
  className?: string
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

export const SpSelect: React.FC<SpSelectProps> = ({
  options,
  value,
  placeholder,
  isDisabled = false,
  className,
  onChange,
}) => (
  <select
    className={`${styles.select} ${value === null || value === '' ? styles.placeholder : ''} ${className || ''}`}
    value={value ?? ''}
    disabled={isDisabled}
    onChange={onChange}
  >
    {placeholder && <option value="">{placeholder}</option>}
    {options.map((opt) => (
      <option key={opt.value} value={opt.value}>
        {opt.label}
      </option>
    ))}
  </select>
)
